import nativeCommsMessageTypes from "../../../nativeComms/nativeCommsMessageTypes";

export default [nativeCommsMessageTypes.EXPAND_PARENT_ITEM, nativeCommsMessageTypes.COLLAPSE_PARENT_ITEM];
